import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { fetchCardMetaDataApi } from '../pages/CardSaga/cardMetaDataSlice';

export default function useCardMetaData() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return cardMetaData;
}
